import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Address } from 'viem';

import { TCryptoCurrency, TxHash } from '../types';

export interface IOngoingCryptoPayment {
  // string here because we are using persisted state.
  // If we use BigNumber, it will be serialized as a string.
  amount: string;
  currency: TCryptoCurrency;
  chainId: number;
  txHash: TxHash;
  isConfirmed?: boolean;
  isError?: boolean;
  accountAddress: Address;
}

interface IOngoingPaymentsState {
  payments: IOngoingCryptoPayment[];
}

interface IPartialRootState {
  ongoingPayments: IOngoingPaymentsState;
}

const initialState: IOngoingPaymentsState = {
  payments: [],
};

export const ongoingPaymentsSlice = createSlice({
  name: 'ongoingPayments',
  initialState,
  reducers: {
    addPayment: (state, action: PayloadAction<IOngoingCryptoPayment>) => {
      state.payments.push(action.payload);
    },
    removePayment: (state, action: PayloadAction<TxHash>) => {
      state.payments = state.payments.filter(
        payment =>
          payment.txHash.toLowerCase() !== action.payload.toLowerCase(),
      );
    },
    markAsConfirmedPayment: (state, action: PayloadAction<TxHash>) => {
      state.payments = state.payments.map(payment => {
        const targetPayment =
          payment.txHash.toLowerCase() === action.payload.toLowerCase();

        if (targetPayment) {
          payment.isConfirmed = true;
        }

        return payment;
      });
    },
    markAsErroredPayment: (state, action: PayloadAction<TxHash>) => {
      state.payments = state.payments.map(payment => {
        const targetPayment =
          payment.txHash.toLowerCase() === action.payload.toLowerCase();

        if (targetPayment) {
          payment.isError = true;
        }

        return payment;
      });
    },
    resetOngoingPayments: () => initialState,
  },
});

export const {
  addPayment,
  markAsConfirmedPayment,
  markAsErroredPayment,
  removePayment,
} = ongoingPaymentsSlice.actions;

export const selectOngoingPayments = (state: IPartialRootState) =>
  state.ongoingPayments.payments;
